import { format } from 'd3-format';

export const formatNodeCount = (count: number) => {
  if (count >= 1000000) {
    return format('.2s')(count);
  }
  if (count >= 10000) {
    return `${Math.round(count / 1000)}k`;
  }
  return format(',')(count);
};
